import { ComponentType } from '@angular/cdk/overlay';
import { createAction, props } from '@ngrx/store';
import {
  Role,
  Roles,
  RPermissions,
  UserRole,
} from '../types';
import { DELETE_DIALOG_DATA } from '@shared/dialogs/types';

const loadRoles = createAction('[Roles] Load Roles');
const loadPermissionList = createAction('[Roles] getPermissionList');
const onLoadRolesSuccess = createAction(
  '[Roles] on Load Roles Success',
  props<{ roles: Roles }>(),
);
const onLoadPermissionListSuccess = createAction(
  '[Roles] on Load Permissions Success',
  props<{
    permissions: RPermissions['permissions'];
    labels: RPermissions['labels'];
  }>(),
);

const onLoadRolesFailure = createAction(
  '[Roles] On Load Roles Failure',
  props<{ error: Error }>(),
);

const onLoadPermissionsFailure = createAction(
  '[Roles] On Load Permissions Failure',
  props<{ error: Error }>(),
);

const creatUserRole = createAction(
  '[Roles] Create User Role',
  props<{ role: UserRole }>(),
);

const fetchUserRole = createAction(
  '[Roles] Edit User Role',
  props<{ roleId: string }>(),
);

const updateUserRole = createAction(
  '[Roles] Update User Role',
  props<{
    roleId: string;
    role: UserRole;
  }>(),
);

const checkRoleDeleteEligibility = createAction(
  '[Roles] Check Role Eligibility',
  props<{
    role: Role;
  }>(),
);

const deleteUserRole = createAction(
  '[Roles] Delete User Role',
  props<{ role: Role; reasonForDelete: string }>(),
);

const clearCurrentUserRole = createAction('[Roles] Clear Current User Role');
const onUpdateUSerRoleSuccess = createAction(
  '[Roles] Update User Role Success',
);
const onUpdateUserRoleFailure = createAction(
  '[Roles] Update User Role Failure',
  props<{ error: Error }>(),
);
const onFetchUserRoleSuccess = createAction(
  '[Roles] on EditUser Role Success',
  props<{ currentRole: Role }>(),
);
const onFetchUserRoleFailure = createAction(
  '[Roles] Edit User Role Failure',
  props<{ error: Error }>(),
);
const onCreateUserRoleSuccess = createAction(
  '[Roles] Create User Role Success',
);
const onCreateUserRoleFailure = createAction(
  '[Roles] Create User Role Failure',
  props<{ error: Error }>(),
);
const onDeleteUserRoleSuccess = createAction(
  '[Roles] Delete User Role Success',
  props<{ role: Role }>(),
);
const onDeleteUserRoleFailure = createAction(
  '[Roles] Delete User Role Failure',
  props<{ error: Error }>(),
);

/**
 * @DIALOG ACTIONS
 * */
const openCheckDeleteEligibilityDialog = createAction(
  '[Roles] Check Eligibility of the role for delete',
  props<{ component: () => ComponentType<unknown>; data: DELETE_DIALOG_DATA }>(),
);

const closeCheckDeleteEligibilityDialog = createAction(
  '[Roles] Close Eligibility dialog',
  props<{ component: ComponentType<unknown> }>(),
);

/**
 * @Display Toast Message
 * */
const displayToastMessage = createAction(
  '[Roles] Display Toast Message',
  props<{ message: string }>(),
);

/**
 * Exporting all actions
 */
export const ROLES_ACTION = {
  checkRoleDeleteEligibility,
  clearCurrentUserRole,
  creatUserRole,
  deleteUserRole,
  fetchUserRole,
  loadPermissionList,
  loadRoles,
  onCreateUserRoleFailure,
  onCreateUserRoleSuccess,
  onDeleteUserRoleFailure,
  onDeleteUserRoleSuccess,
  onFetchUserRoleFailure,
  onFetchUserRoleSuccess,
  onLoadPermissionListSuccess,
  onLoadPermissionsFailure,
  onLoadRolesFailure,
  onLoadRolesSuccess,
  onUpdateUSerRoleSuccess,
  onUpdateUserRoleFailure,
  updateUserRole,
};

/*
 * @ROLES DIALOG ACTIONS
 * */
export const ROLES_DIALOG_ACTION = {
  closeCheckDeleteEligibilityDialog,
  openCheckDeleteEligibilityDialog,
};

/**
 * @ROLES TOAST ACTIONS
 * */
export const ROLE_TOAST_ACTION = {
  displayToastMessage,
};
